(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('nl')) return;
  const fix = root => {
    const links = root.matches?.('a[href]') ? [root] : [];
    root.querySelectorAll?.('a[href]').forEach(link => links.push(link));
    links.forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin) return;
      if (url.pathname === '/pages/request-for-quote' || url.pathname === '/collections/all' && link.closest('.grfq-popup, .grfq__popupForm__modal, #grfq-page')) {
        url.pathname = '/nl' + url.pathname;
        link.setAttribute('href', url.pathname + url.search + url.hash);
      }
    });
  };
  fix(document);
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (link) fix(link);
  }, true);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) fix(node);
  }))).observe(document.body, {childList:true,subtree:true});
})();